<template>
  <div>
    <page-header :title="$t('common.create') + $t('aice.aiproxy.routing')" />
    <page-body needMarginBottom>
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" class="mt-4">
        <a-form-model-item :label="$t('common.name')" prop="generate_name">
          <a-input v-model="form.generate_name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('aice.aiproxy.model_key')" prop="model_key">
          <a-input v-model="form.model_key" :placeholder="$t('aice.aiproxy.routing_model_key_tip')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('aice.aiproxy.priority')">
          <a-input-number v-model="form.priority" :min="0" />
        </a-form-model-item>
        <a-form-model-item :label="$t('aice.aiproxy.ai_proxy_node_id')">
          <base-select v-model="form.ai_proxy_node_id" resource="ai_proxy_nodes" :params="{ scope: $store.getters.scope }" filterable version="v2" />
        </a-form-model-item>
        <a-divider orientation="left">{{ $t('aice.aiproxy.routing_models') }}</a-divider>
        <div v-for="(item, index) in models" :key="item._key">
          <model-binding-row
            :item="item"
            :index="index"
            @remove="removeModel"
            @model-key-suggest="onModelKeySuggest" />
        </div>
        <a-button type="dashed" icon="plus" block class="mb-4" @click="addModel">{{ $t('aice.aiproxy.add_model_binding') }}</a-button>
      </a-form-model>
    </page-body>
    <page-footer>
      <template v-slot:right>
        <a-button type="primary" :loading="loading" @click="handleSubmit">{{ $t('common.create') }}</a-button>
        <a-button class="ml-2" @click="handleCancel">{{ $t('dialog.cancel') }}</a-button>
      </template>
    </page-footer>
  </div>
</template>

<script>
import { validateModelForm } from '@/utils/validate'
import { PROVIDER_KIND_DEFAULT } from '@Ai/utils/aiProviderKind'
import ModelBindingRow from '../components/ModelBindingRow'

let keySeq = 0

export default {
  name: 'AiRoutingCreate',
  components: { ModelBindingRow },
  data () {
    return {
      loading: false,
      form: {
        generate_name: '',
        model_key: '',
        priority: 0,
        ai_proxy_node_id: '',
      },
      models: [this.newModel()],
      rules: {
        generate_name: [{ required: true, validator: this.$validate('resourceName') }],
        model_key: [{ required: true, validator: this.validateModelKey }],
      },
    }
  },
  methods: {
    validateModelKey (rule, value, callback) {
      if (String(value || '').trim()) {
        callback()
        return
      }
      callback(new Error(this.$t('aice.aiproxy.routing_model_key_required')))
    },
    newModel () {
      return {
        _key: ++keySeq,
        provider_kind: PROVIDER_KIND_DEFAULT,
        ai_provider_id: '',
        ai_model_id: '',
        priority: 0,
      }
    },
    addModel () {
      this.models.push(this.newModel())
    },
    removeModel (index) {
      if (this.models.length > 1) this.models.splice(index, 1)
    },
    onModelKeySuggest (modelKey) {
      if (!String(this.form.model_key || '').trim() && modelKey) {
        this.form.model_key = modelKey
      }
    },
    handleCancel () {
      this.$router.push('/ai-routing')
    },
    buildModelsPayload () {
      return this.models
        .filter(m => m.ai_provider_id && m.ai_model_id)
        .map(m => ({
          ai_provider_id: m.ai_provider_id,
          ai_model_id: m.ai_model_id,
          priority: m.priority || 0,
        }))
    },
    async handleSubmit () {
      await validateModelForm(this.$refs.form)
      const models = this.buildModelsPayload()
      if (!models.length) {
        this.$message.warning(this.$t('aice.aiproxy.models_required'))
        return
      }
      this.loading = true
      try {
        await new this.$Manager('ai_routings').create({
          data: {
            generate_name: this.form.generate_name,
            model_key: this.form.model_key,
            priority: this.form.priority,
            ai_proxy_node_id: this.form.ai_proxy_node_id || undefined,
            models,
          },
        })
        this.handleCancel()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
